import React, { useEffect, useState } from "react";
import { Paper, InputBase, IconButton, Box, Grid } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import SearchBar from "components/commonSearch/SearchBar";
import CommonDateRangePicker from "components/commonDateRangePicker/CommonDateRangePicker";
import CommonFilter from "components/commonFilter/CommonFilter";

export default function CommonSDF(props) {
    console.log("props in common sdf", props);  
    return (
        <>
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: { xs: 'column', sm: 'column', md: 'row', lg: 'row' },
                    alignItems: { xs: 'stretch', sm: 'stretch', md: 'center', lg: 'center' },
                    justifyContent: { lg: 'flex-end', md: 'flex-end', sm: 'flex-start', xs: 'flex-start' },
                    width: '100%',
                    gap: { xs: 1, sm: 1, md: 2, lg: 2 }
                }}
            >
               
                <Box sx={{ 
                    width: { 
                        xs: '100%', 
                        sm: '100%', 
                        md: props?.tabName === "complaints" ? '280px' : 'auto',
                        lg: props?.tabName === "complaints" ? '280px' : 'auto'
                    }
                }}>
                    <SearchBar
                        {...props}
                        onSearchQuery={props?.onSearchQuery}
                        placeholder={
                            props?.tabName === "complaints" 
                            ? "Search by Ticket Id" 
                            : "Search"
                        }
                        fullWidth
                    />
               </Box>
            
                {(props.tabName !== "company" && props.tabName !== "complaints") && (
                    <Box sx={{ 
                        width: {
                            xs: '100%',
                            sm: '100%',
                            md: '280px',
                            lg: '280px'
                        },
                        marginRight: { md: '20px', lg: '20px', xs: '0', sm: '0' }
                    }}>
                        <CommonDateRangePicker
                            {...props}
                            allowFutureDates={true}
                        />
                    </Box>
                )}
                {(props.filter || props.tabName === "complaints") && (
                    <Box sx={{ 
                        width: { 
                            xs: '100%', 
                            sm: '100%', 
                            md: 'auto', 
                            lg: 'auto' 
                        }
                    }}>
                        <CommonFilter
                            {...props}
                        />
                    </Box>
                )}
            </Box>
        </>
    )
}
